// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__ziaOW","btn":"BlogCard_btn__3cI_V","extra":"BlogCard_extra__13HuY"};